// getApps投放
// 方案：针对mobile-legends游戏及source=Getapps 进行页面定制
import { getQuery } from '@/utils/utils'
const GAME_NAME = 'mobile-legends'
const SPE_SOURCE = 'getapps'

export function isNeedDeal() {
  if (!process.client) return false
  let source = getQuery('source') || ''
  if (
    window.location.href.includes(GAME_NAME) &&
    source.toLowerCase() === SPE_SOURCE
  ) {
    return true
  }
  return false
}
